import { render, staticRenderFns } from "./areaPasswordForgotten.vue?vue&type=template&id=4c5a622a&scoped=true&"
import script from "./areaPasswordForgotten.vue?vue&type=script&lang=js&"
export * from "./areaPasswordForgotten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5a622a",
  null
  
)

export default component.exports